<template>
    <v-dialog v-model="dialogueProp" width="1200" scrollable>
        <v-card>
            <v-toolbar class="close-btn" flat>
                <v-btn icon @click="dialogueProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider />
            <div v-if="getDependentUtil" class="util-container">
                <!-- Dependent Utilization/s -->
                <div v-resize="onResize" style="width:85%; margin:auto;">
                    <div v-if="dependentSelection === cardCount">
                        <div class="text-center mt-5">
                            <h3>{{ dependentName }}</h3>
                        </div>
                        <div style="background-color: white; padding: 3px; border-radius: 5px;">
                            <v-alert
                                color="teal darken-3"
                                outlined
                                style="margin: 0;"
                                type="info"
                            >
                                <span>Note: The information reported on this page is not displayed in real time, and still subject to succeeding updates.</span>
                            </v-alert>
                        </div>
                        <br>
                        <!-- DATA TABLE -->
                        <v-data-table
                            :headers="headers"
                            :items="getDependentUtil"
                            :items-per-page="10"
                            class="mt-5 elevation-5"
                            :footer-props="footer_props"
                            :class="{ mobile: isMobile }"
                        >
                            <template #item="{ item }">
                                <!-- IF DESKTOP VIEW -->
                                <TblRowDsktpView
                                    v-if="item.BILL_T != null"
                                    :is-mobile="isMobile"
                                    :table-items="item"
                                />

                                <!-- IF MOBILE VIEW -->
                                <TblRowMblView
                                    v-if="item.BILL_T != null"
                                    :is-mobile="isMobile"
                                    :table-items="item"
                                />

                                <tr v-else>
                                    <td :colspan="headers.length" class="text-center">
                                        <h1>No Utilizations</h1>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                        <!-- END DATA TABLE -->
                    </div>
                    <br>
                    <br>
                    For more information, please contact HMI.
                    <br>
                    <br>
                </div>
                <!-- End Dependent Utilization/s -->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { moment } from '../../../utils/date-shim'
import TblRowDsktpView from '../TblRows/TblRowDsktpView.vue'
import TblRowMblView from '../TblRows/TblRowMblView.vue'
import { mapGetters } from 'vuex'
import { mdiClose } from '@mdi/js'
export default {
    components: {
        TblRowDsktpView,
        TblRowMblView
    },
    props: ['getDependentUtil', 'dependentSelection', 'cardCount', 'showDependentUtil', 'dependentName'],
    data: () => ({
        mdiClose,
        isMobile: false,
        footer_props: {
            'items-per-page-options': [5]
        },
        headers: [
            {
                text: 'Admission Date',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Release Date',
                align: 'center',
                sortable: false,
                class: 'teal--text'
            },
            {
                text: 'Availment Type',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Hospital/Clinic Name',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Doctor Name',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },

            {
                text: 'Hospital Bill Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },
            {
                text: 'Professional Fee',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            },

            {
                text: 'Diagnosis',
                sortable: false,
                align: 'center',
                class: 'teal--text'
            }
            // {
            //   text: "Procedure",
            //   sortable: false,
            //   align: "center",
            //   class: "teal--text",
            // },
        ]
    }),
    computed: {
        ...mapGetters(['NoUtil']),
        dialogueProp: {
            get() {
                return this.showDependentUtil && this.cardCount === this.dependentSelection
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    },
    methods: {
        onResize() {
            if (window.innerWidth < 968) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        },
        formatDate(date) {
            if (date == null) {
                return '-'
            } else {
                return moment(date).utcOffset('+0800').format('MMMM DD, YYYY')
            }
        }
    }
}
</script>

<style scoped>
.close-btn{
  display: flex;
  align-items: right;
  justify-content: right;
}

.util-container {
  background-color:white;
}

h1 {
    font-size: 18px;
}

@media (max-width: 968px) {

  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  .flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
  }

  label {
    width: 60%;
    font-weight: bold;
    padding: 5px;
  }
}
</style>
